import { render, staticRenderFns } from "./NewsProgramBox.vue?vue&type=template&id=4363b049&"
import script from "./NewsProgramBox.vue?vue&type=script&lang=js&"
export * from "./NewsProgramBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports